import UUHukumContent from "../../../components/layouts/ncb_interpol/UUHukumContent";

import React from "react";

const UUHukum: React.FC = () => {
  return (
    <div>
      <UUHukumContent />
    </div>
  );
};

export default UUHukum;
